import gql from "graphql-tag";
import {
    ScheduledCgoNodeFragment,
    ScheduledPaxNodeFragment
} from "../../../../../Queries/Scheduling";
import {ScheduledToExpectedPaxCgoResponse} from "../../../../../__generated__/graphql/types";

export const ScheduledToExpectedPaxCgoMutation = gql`
    mutation ScheduledToExpectedPaxCgoTool($paxIDs: [ID!], $cgoIDs: [ID!]){
        ScheduledToExpectedPaxCgo(paxIDs: $paxIDs, cgoIDs: $cgoIDs){
            paxNodes {
                ...ScheduledPaxNodeFragment
            }
            cgoNodes {
                ...ScheduledCgoNodeFragment
            }
        }
    }
    ${ScheduledPaxNodeFragment}
    ${ScheduledCgoNodeFragment}
`